module.exports = __webpack_public_path__ + "static/media/edit-source.00734569.png";